export default theme => ({
    wrapper: {
        position: 'relative',
        width: '100%'
    },
    scrollbars: {
        marginTop: 10,
        maxHeight: 900,
        overflow: 'auto',
        padding: '0 0 33px',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            maxHeight: 400,
            display: 'flex',
            overflowX: 'auto',
            padding: '10px 0'
        },
        '& > div': {
            maxWidth: '100%',
            marginBottom: 20,
            [theme.breakpoints.down('md')]: {
                marginRight: 20,
                marginBottom: 0
            }
        }
    }
});
